import axios from 'axios';

/**
 * Create and configure axios instance
 */
export default axios.create({
    baseURL: 'https://demo-api.now.sh'
})
